export const AUTH_TOKEN_EXPIRED = 'AUTH_TOKEN_EXPIRED';
export const BAD_CREDENTIALS = 'BAD_CREDENTIALS';
export const FORBIDDEN_ACCESS = 'FORBIDDEN_ACCESS';
export const ACCOUNT_DISABLED = 'ACCOUNT_DISABLED';
export const ENTITY_NOT_FOUND = 'ENTITY_NOT_FOUND';
export const INVALID_RECAPTCHA_RESPONSE = 'INVALID_RECAPTCHA_RESPONSE';
